import AccountSettings from "./component";

export default AccountSettings;
